export const actionTypes = {
  SET_DATA: 'TAPS.TAX_OBJECT.SET_DATA',
  SEND_DATA: 'TAPS.TAX_OBJECT.SEND_DATA',
  RESET: 'TAPS.TAX_OBJECT.RESET',
};

export function setTaxObjectData(data) {
  return {
    type: actionTypes.SET_DATA,
    payload: data,
  };
}

export function sendRealtyObject(data) {
  return {
    type: actionTypes.SEND_DATA,
    payload: data,
  };
}

export function reset() {
  return {
    type: actionTypes.RESET,
  };
}
